/* eslint-disable */
export default {
  ringtones: 'Soittoäänet',
  incomingRingtone: 'Saapuvan puhelun soittoääni',
  outgoingRingtone: 'Lähtevän puhelun soittoääni',
  play: 'Toista',
  stop: 'Lopeta',
  upload: 'Lähetä',
  reset: 'Palauta',
  save: 'Tallenna',
} as const;

// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"incomingRingtone"@#@ @source: @#@"Incoming Ringtone"@#@
// @key: @#@"outgoingRingtone"@#@ @source: @#@"Outgoing Ringtone"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"stop"@#@ @source: @#@"Stop"@#@
// @key: @#@"upload"@#@ @source: @#@"Upload"@#@
// @key: @#@"reset"@#@ @source: @#@"Reset"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
